import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export type KeyStateType = 'production' | 'test';

type TokenStateToggleProps = {
  selectedState: KeyStateType;
  onTokenStateChange: (tokenState: KeyStateType) => void;
};

export const TokenStateToggle = ({
  selectedState,
  onTokenStateChange,
}: TokenStateToggleProps) => {
  const theme = useTheme(); // Get the MUI v5 theme

  const handleTokenStateChange = (
    event: React.MouseEvent<HTMLElement>,
    tokenState: KeyStateType
  ) => {
    if (tokenState !== null) {
      onTokenStateChange(tokenState);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2),
      }}
    >
      <ToggleButtonGroup
        value={selectedState}
        exclusive
        onChange={handleTokenStateChange}
        sx={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 4,
          height: 30,
        }}
      >
        <ToggleButton
          value="production"
          sx={{
            borderRadius: 4,
            height: 30,
            '&.Mui-selected': {
              backgroundColor: theme.palette.info.main,
              color: theme.palette.common.white,
            },
          }}
        >
          Production
        </ToggleButton>
        <ToggleButton
          value="test"
          sx={{
            borderRadius: 4,
            height: 30,
            '&.Mui-selected': {
              backgroundColor: theme.palette.info.main,
              color: theme.palette.common.white,
            },
          }}
        >
          Test
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};
